import PageTitleBlockType from "./PageTitleBlockType";
import styles from "./PageTitleBlock.module.scss"
import PageTitle from "../../atoms/PageTitle/PageTitle";
import PageSubTitle from "../../atoms/PageSubTitle/PageSubTitle";

const PageTitleBlock = (props: PageTitleBlockType) => {
  const {id, pageTitle,pageSubTitle, commonClass} = props;
  return (
    <div id={id} className={`${styles.PageTitleBlock} ${commonClass && styles[commonClass]}`}>
      <PageTitle 
        id={pageTitle.id}
        text={pageTitle.text}
        commonClass={pageTitle.commonClass}
      />
      <PageSubTitle 
        id={pageSubTitle.id}
        text={pageSubTitle.text}
        commonClass={pageSubTitle.commonClass}
      />
    </div>
  )
}

export default PageTitleBlock;